(function() {
  angular.module('benefits')
    .service('printBenefitsHelper', function() {
          let _printableProcedureCodes = {};

         function printableProcedureCodes(key, printableSection) {
          if (key && printableSection) {
            _printableProcedureCodes[key] = printableSection;
          }
          if (key && !printableSection) {
            return _printableProcedureCodes[key] ;
          }
          return _printableProcedureCodes;
        }

        function initPrintables() {
           initPrintableProdedureCodes();
        }

        function initPrintableProdedureCodes() {
          _printableProcedureCodes = {};
        }

      return {
        printableProcedureCodes : printableProcedureCodes,
        initPrintables : initPrintables,
        initPrintableProdedureCodes: initPrintableProdedureCodes
      };
    });
})();
